import dayjs, { Dayjs } from 'dayjs';

export const getDate = (date: Dayjs | null) =>
  !date ? '' : dayjs(date).format('YYYY-MM-DD');
